/*
    数据请求地址的资源列表
*/
import appConfig from './appConfig.js';

const serviceHost = appConfig.serviceHost;  //后台服务地址
const serviceHost2 = appConfig.serviceHost2;  //后台服务地址
const okapiHost = appConfig.okapiHost;    //远程okapi地址

export const urlStatus = {
    okStatu: 200
};
export const adminId = 'ADMIN201700014';
export const expertId = 'E201700010';
export const accessUrlConfig = {
    //指标定义
    indices: {
        get: serviceHost + 'Indices/get',  //查询一条数据
        queryAll: serviceHost + 'Indices/query',  //查询所有数据
        query: serviceHost + 'Indices/query2', //查询所有数据带分页
        queryPageAndOrder: serviceHost + 'Indices/query3', //查询所有数据带分页和排序
        add: serviceHost + 'Indices/add',  //新增指标信息  methods：post
        edit: serviceHost + 'Indices/modify',  //修改指标信息  methods：PUT
    },
    //指标配置信息
    indicesVersionConfig: {
        get: serviceHost + 'IndicesVersionConfig/get',  //查询一条数据
        add: serviceHost + 'IndicesVersionConfig/add',    //添加数据
        modify: serviceHost + 'IndicesVersionConfig/modify', //修改数据
        queryPage: serviceHost + 'IndicesVersionConfig/queryByPage', //查询所有数据带分页
        queryPageAndOrder: serviceHost + 'IndicesVersionConfig/queryByPageAndOrder', //查询所有数据带分页和排序
        getCurrentEvaluateIVC: serviceHost + "IndicesVersionConfig/getCurrentEvaluateIVC",//获得评价指标列表
        getCurrentStatisticsIVC: serviceHost + "IndicesVersionConfig/getCurrentStatisticsIVC"//获得统计指标列表
    },
    //管理员个人信息
    accountAdmin: {
        getEntity: serviceHost + 'account/admin_info/one?adminId=',//根据管理员Id获取管理员对象信息
        password: serviceHost + 'account/admin_info/password',//管理员修改密码
        modify: serviceHost + 'account/admin_info/modify',//管理员修改信息
        getEntityByOkapiUserId: serviceHost + 'account/admin_info/okapiuser?okapiUserId=', //根据okapiUserId获取管理员信息
        getEntityByLoginName: serviceHost + 'account/admin_info/login_name?loginName=' //根据用户登录名获取管理员信息
    },
    //专家个人信息
    accountExpert: {
        getEntity: serviceHost + 'account/expert_info/one?eId=',//根据专家Id获取专家信息
        password: serviceHost + 'account/expert_info/password',//专家修改密码
        modify: serviceHost + 'account/expert_info/modify',//专家修改信息
        getEntityByOkapiUserId: serviceHost + 'account/expert_info/okapiuser?okapiUserId=', //根据okapiUserId获取专家信息
        getEntityByLoginName: serviceHost + 'account/expert_info/login_name?loginName=' //根据用户登录名获取专家信息
    },
    //取得学科列表
    subject: {
        query: serviceHost + 'src_subject_service/query',
        map: serviceHost + 'src_subject_service/map',
        query2: serviceHost + 'src_subject_service/query',//统计学科list
    },
    //取字典表内数据
    dictionnary: {
        query: serviceHost + 'dictionary/list2'
    },
    //期刊相关系统
    journal: {
        import: serviceHost + 'journal/journal_info/import',
        exportAll: serviceHost + 'journal/journal_info/exportAll',
        query: serviceHost + 'journal/journal_info/query',
        add: serviceHost + 'journal/journal_info/add',
        modify: serviceHost + 'journal/journal_info/modify',
        modify_journal: serviceHost + 'journal/journal_info/modifyJournal',
        delete_journal: serviceHost + 'journal/journal_info/delete',
        delete_journals: serviceHost + 'journal/journal_info/delete_batch',
        history: serviceHost + 'journal/journal_info/history_info',
        evaluate: serviceHost + 'journal/journal_info/history_evaluate_info',
        update_batch: serviceHost + 'journal/journal_info/update_batch',
        getOne: serviceHost + 'journal/journal_info/one',
        getzjOne: serviceHost + 'journal/journal_info/zjone'
    },
    //期刊历史沿革相关
    journalHistory: {
        import: serviceHost + 'journal/history_info/import',
        query: serviceHost + 'journal/history_info/query',
        create: serviceHost + 'journal/history_info/add',
        modify: serviceHost + 'journal/history_info/modify'
    },
    //核心类目管理
    coreCategoryConfig: {
        tree_all: serviceHost + 'evaluate_subject/core_tree',    //左侧树无权限
        query: serviceHost + 'evaluate_subject/core_query', //树形搜索
        export:serviceHost+'evaluate_subject/core_export',//导出
    },
    //评价学科管理
    evaluateSubjectConfig: {
        tree_all: serviceHost + 'evaluate_subject/tree_all',    //左侧树无权限
        tree: serviceHost + 'evaluate_subject/tree',    //左侧树有权限
        tree_yj: serviceHost + 'evaluate_subject/tree_yj', //研究人员左侧树
        query: serviceHost + 'evaluate_subject/query', //树形搜索
        query_pageorder: serviceHost + 'evas_vinfo/query_pageorder', //版本信息查询数据带分页和排序
        update_status: serviceHost + 'evas_vinfo/update_status', //修改启用版本
        modify: serviceHost + 'evaluate_subject/modify_evaluate_subject',//修改评价学科数据
        add: serviceHost + 'evaluate_subject/add_evaluate_subject',//添加评价学科数据
        all: serviceHost + 'evaluate_subject/allList',//查询全部
        
    },
    //初始化核心/扩展刊，权重
    initdlCoreWeightinfoConfig: {
        initdl_core_get: serviceHost + 'initdl_core_extend/get',    //获取右侧的核心刊和扩展刊数量
        init_weight_get: serviceHost + 'init_weightinfo/get',    //获取右侧的权重
        init_weight_update: serviceHost + 'init_weightinfo/updata',  //提交权重信息
        initdl_core_extend_update: serviceHost + 'initdl_core_extend/update',  //提交修改
        initdl_get_reference: serviceHost + 'initdl_core_extend/get_reference',//返回图表数据
    },
    //总编化核心/扩展刊，权重
    zbCoreWeightinfoConfig: {
        zb_core_get: serviceHost + 'zbCoreExtend/get',    //获取右侧的核心刊和扩展刊数量
        zb_core_update: serviceHost + 'zbCoreExtend/update',  //提交核心刊和扩展刊修改
        zb_core_update_two: serviceHost + 'zbCoreExtend/update_two',  //提交核心刊和扩展刊修改 定量2
        zd_get_reference_one: serviceHost + 'ZbCoreExtend/get_reference_one',//返回图表数据 定量1
        zb_get_reference_tow: serviceHost + 'ZbCoreExtend/get_reference_tow',//返回图表数据 定量2
        zb_weight_get: serviceHost + 'zbWeightinof/get',    //获取右侧的权重
        zb_weight_update: serviceHost + 'zbWeightinof/updata',  //提交权重信息
    },
    //大编化核心/扩展刊，权重
    dbCoreWeightinfoConfig: {
        db_core_get: serviceHost + 'dbCoreExtend/get',    //获取右侧的核心刊和扩展刊数量
        db_core_update: serviceHost + 'dbCoreExtend/update',  //提交核心刊和扩展刊修改
        db_get_reference: serviceHost + 'dbCoreExtend/get_reference',//返回图表数据
        db_weight_get: serviceHost + 'dbWeightinof/get',    //获取右侧的权重
        db_weight_update: serviceHost + 'dbWeightinof/updata',  //提交权重信息
    },
    //研究人员化核心/扩展刊，权重
    yjCoreWeightinfoConfig: {
        yj_core_get: serviceHost + 'yjCoreExtend/get',    //获取右侧的核心刊和扩展刊数量
        yj_core_update: serviceHost + 'yjCoreExtend/update',  //提交核心刊和扩展刊修改
        yj_get_reference: serviceHost + 'yjCoreExtend/get_reference',//返回图表数据
        yj_weight_get: serviceHost + 'yjWeightinof/get',    //获取右侧的权重
        yj_weight_update: serviceHost + 'yjWeightinof/updata',  //提交权重信息
    },
    //统计学科
    statisticalDisciplineConfig: {
        tree: serviceHost + 'src_subject_service/tree',    //左侧树
    },
    //代码表
    dictionaryConfig: {
        query: serviceHost + 'dictionary/list2',    //代码表
    },
    //学科表
    subjectConfig: {
        list2: serviceHost + 'subject/list2',    //学科表
    },
    //文件上传oss地址
    uploadOss: {
        uploadURL: 'http://162.105.139.39:10080/api/subscrip/upload'
    },
    //请求okapi用户平台相关url
    okapiReqUrl: {
        loginOkapi: okapiHost + '',//登录okapi 用户平台验证
        searchOkapiId: okapiHost.replace('bl-users/login', '') + 'authn/credentials?query=userId==',//根据okapiUserId查询okapi用户的主键
        passwordOkapi: okapiHost.replace('bl-users/login', '') + 'authn/credentials/', //修改okapi用户平台的密码
    },
    //系统参数
    system: {
        version: serviceHost + "getCurVersion"         //GET 获取当前版次信息
    },
    datasrc: {
        sources: serviceHost + "datasrc/sources/list"         //GET 获取指标数据源
    },
    //导入模板信息获取
    mouldUrl: {
        getMouldMap: serviceHost + 'mould/map?piType=' //根据类型获取导入模板信息ID和名称的键值对
    },
    //操作查询
    operationLog: {
        get: serviceHost + 'operationLog/detail',//根据id查询单个记录 GET
        query: serviceHost + 'operationLog/query',//查询记录列表 POST
        table: serviceHost + 'operationLog/table_name', //数据表下拉项
        type: serviceHost + 'operationLog/operation_type',//操作类型下拉项
    },
    //权限配置
    rightConfig: {
        add: serviceHost + "roleManage/add",// 添加 post
        del: serviceHost + "roleManage/delete",// 添加 post
        update: serviceHost + "roleManage/modify", //修改 put
        one: serviceHost + "roleManage/detail",//单个
        query: serviceHost + "roleManage/query",//角色列表
        list: serviceHost + "roleManage/list",//全部列表
        tree: serviceHost + "roleManage/role_menu_tree",//角色树
        userTree: serviceHost + "roleManage/user_menu_tree",//树
        expert_eval: serviceHost + 'expert_dx_jnl_eva/query_is_open_expert_eval',
    },
    //管理员维护
    adminInfo: {
        add: serviceHost + "adminInfo/add",//添加
        del: serviceHost + "adminInfo/delete",//删除
        update: serviceHost + "adminInfo/modify",//更新
        query: serviceHost + "adminInfo/query",//列表
        one: serviceHost + "account/admin_info/one",//单个
        tree: serviceHost + "evaluate_subject/tree_syx",//tree
    },
    //专家信息
    expertInfo: {
        add: serviceHost + "expertInfo/add",//添加
        del: serviceHost + "expertInfo/delete",//删除
        update: serviceHost + "expertInfo/modify",//更新
        query: serviceHost + "expertInfo/query",//列表
        one: serviceHost + "account/expert_info/one",//单个
        batchSend: serviceHost + 'expertInfo/send_email',//批量发送邮件
        batchSendsms: serviceHost + 'expertInfo/send_sms',//批量发送邮件
        import: serviceHost + 'expertInfo/import',//导入
        modify: serviceHost + 'expertInfo/apply_modify',//修改
        reset: serviceHost + 'expert_dx_jnl_eva/reset_expert_evaluate_subject',//重置评价学科,
        applyStatus:serviceHost + 'account/expert_info/applyStatus'
    },
    //期刊黑名单
    black: {
        add: serviceHost + "journalBlack/add",//添加
        update: serviceHost + "journalBlack/update",//更新
        query: serviceHost + "journalBlack/query",//列表
        one: serviceHost + "journalBlack/detail",//单个
        export: serviceHost + "journalBlack/export",//导出 POST
        queryJournal: serviceHost + "journalBlack/query_history_evaluate_info",//期刊列表 POST
    },
    //获奖与检索收录
    prize:{
        list:serviceHost + "prizejnl/list",//获取列表
        listPrizeInfo:serviceHost + "prizejnl/queryPrizeInfoByJId",
        add:serviceHost + "prizejnl/addPrizeInfo",//增加获奖信息
        modify:serviceHost + "prizejnl/modifyPrizeInfo",//修改获奖信息
        delete:serviceHost + "/prizejnl/delPrizeInfo",//修改获奖信息
        export:serviceHost + "prizejnl/export"//导出
    },
    //邮件管理
    email: {
        batchSend: serviceHost + "emailRecord/batch_resend",//批量发送
        singleSend: serviceHost + "emailRecord/single_resend",//单个发送
        query: serviceHost + "emailRecord/query",//列表
        one: serviceHost + "emailRecord/detail",//获取单个信息
        expertCount: serviceHost + "emailRecord/query_resend_batch_expert_count",
        temp: serviceHost + "getAdvertisePara",           //邮件模板
    },
    //短信管理
    message: {
        batchSend: serviceHost + "smsRecord/batch_resend",//批量发送
        singleSend: serviceHost + "smsRecord/single_resend",//单个发送
        query: serviceHost + "smsRecord/query",//列表
        one: serviceHost + "smsRecord/detail",//获取单个信息
        expertCount: serviceHost + "smsRecord/query_resend_batch_expert_count",
        temp: serviceHost + "getAdvertisePara",           //短信模板
    },
    //菜单
    menuConfig: {
        add: serviceHost + "menuConfig/add",//添加
        update: serviceHost + "menuConfig/modify",//更新
        query: serviceHost + "menuConfig/query",//列表
        one: serviceHost + "menuConfig/detail",//单个
        delete: serviceHost + "menuConfig/delete",//删除

    },

    //-----三期接口--------
    //大编定性评价
    bigEditorNature: {
        tree: serviceHost + 'dbdx_formal_jnleva/tree',// tree
        query: serviceHost + 'dbdx_formal_jnleva/query',//查询
        //多学科核心期刊/多学科扩展期刊评价数量，期刊总数，核心，扩展刊数，是否提交审核意见接口
        describe: serviceHost + 'dbdx_formal_jnleva/get_statistics_info',
        //获取期刊排名
        get_ranking: serviceHost + 'dbdx_formal_jnleva/get_ration',
        //保存期刊排名
        save_ranking: serviceHost + 'dbdx_formal_jnleva/save_ration',
        //核心刊扩展刊数量
        getCoreExt: serviceHost + 'dbdx_formal_jnleva/get_core_extensions',
        //保存核心刊扩展刊数量
        saveCoreExt: serviceHost + 'dbdx_formal_jnleva/save_core_extensions',
        //获取审核意见
        getAudit: serviceHost + 'dbdx_formal_jnleva/get_audit_opinion',
        //保存审核意见
        saveAudit: serviceHost + 'dbdx_formal_jnleva/update_audit_opinion',
    },


    //大编定性汇总
    bigEditorSummary: {
        //Tree
        tree: serviceHost + 'dbdx_formal_jnleva_summary/tree',
        //查询列表
        query: serviceHost + 'dbdx_formal_jnleva_summary/query',
        //多学科核心期刊/多学科扩展期刊评价数量，期刊总数，核心，扩展刊数，是否提交审核意见接口
        describe: serviceHost + 'dbdx_formal_jnleva_summary/get_statistics_info',
        //获取期刊排名
        get_ranking: serviceHost + 'dbdx_formal_jnleva_summary/get_ranking',
        //保存期刊排名
        save_ranking: serviceHost + 'dbdx_formal_jnleva_summary/many_subject_ext_save',
        //核心刊扩展刊数量
        getCoreExt: serviceHost + 'dbdx_formal_jnleva_summary/get_core_extensions',
        //保存核心刊扩展刊数量
        saveCoreExt: serviceHost + 'dbdl_formal_jnleva_summary/save_core_extensions',
        //获取审核意见
        getAudit: serviceHost + 'dbdx_formal_jnleva_summary/get_audit_opinion',
        //保存审核意见
        saveAudit: serviceHost + 'dbdx_formal_jnleva_summary/update_audit_opinion',
        //导出
        export: serviceHost + 'dbdx_formal_jnleva_summary/get_export',
        //多学科核心刊列表
        moreCoreQuery: serviceHost + 'dbdx_formal_jnleva_summary/many_subject_query',
        //设置-多学科核心刊
        setMoreCore: serviceHost + 'dbdx_formal_jnleva_summary/many_subject_save',
        //多学科扩展刊列表
        moreExtQuery: serviceHost + 'dbdx_formal_jnleva_summary/many_subject_ext_query',
        //设置-多学科扩展刊
        setExtCore: serviceHost + 'dbdx_formal_jnleva_summary/many_subject_ext_save',
        //多学科扩展期刊评价 编辑页面信息读取接口
        many_subject_ext_get: serviceHost + 'dbdx_formal_jnleva_summary/many_subject_ext_get',
        //上版核心期刊
        upper_edition_coreJnl: serviceHost + 'dbdx_formal_jnleva_summary/upper_edition_coreJnl',
    },

    //总编定性评价
    EditorNatureEvaluate: {
        //Tree
        tree: serviceHost + 'zbdx_jnl_eva/tree',
        //查询列表
        query: serviceHost + 'zbdx_solr_api/query',
        //多学科核心期刊/多学科扩展期刊评价数量，期刊总数，核心，扩展刊数，是否提交审核意见接口
        describe: serviceHost + 'zbdx_jnl_eva/get_statistics_info',
        //获取期刊排名
        get_ranking: serviceHost + 'zbdx_solr_api/get_ration',
        //保存期刊排名
        save_ranking: serviceHost + 'zbdx_solr_api/save_ration',
        //保存期刊排名（新）
        save_ranking_new: serviceHost + 'zbDxEvaluate/mcj/journal_move_rank',
        //核心刊扩展刊数量
        getCoreExt: serviceHost + 'zbdx_jnl_eva/get_core_extensions',
        //保存核心刊扩展刊数量
        saveCoreExt: serviceHost + 'zbdx_solr_api/save_core_extensions',
        //获取审核意见
        getAudit: serviceHost + 'zbdx_jnl_eva/get_audit_opinion',
        //保存审核意见
        saveAudit: serviceHost + 'zbdx_jnl_eva/update_audit_opinion',
        //导出
        export: serviceHost + 'zbdx_solr_api/export',
        //多学科核心刊列表
        moreCoreQuery: serviceHost + 'zbdx_jnl_eva/many_subject_query',
        //多学科核心刊列表（新）
        moreCoreQueryNew: serviceHost + 'zbDxEvaluate/mcj/get_multiple_core_juornals',
        //设置-多学科核心刊
        setMoreCore: serviceHost + 'zbdx_solr_api/many_subject_save',
        //多学科扩展刊列表
        moreExtQuery: serviceHost + 'zbdx_jnl_eva/many_subject_ext_query',
        //设置-多学科扩展刊
        setExtCore: serviceHost + 'zbdx_jnl_eva/many_subject_ext_save',
        //多学科扩展期刊评价 编辑页面信息读取接口
        many_subject_ext_get: serviceHost + 'zbdx_solr_api/get_ration',
        //上版核心期刊
        upper_edition_coreJnl: serviceHost + 'zbdx_jnl_eva/upper_edition_coreJnl',
    },
    //总编综合评价
    EditorSyntheticalEvaluate: {
        //Tree
        tree: serviceHost + 'zbzh_jnl_eva/tree',
        //查询列表
        query: serviceHost + 'zbzh_solr_api/query',
        //多学科核心期刊/多学科扩展期刊评价数量，期刊总数，核心，扩展刊数，是否提交审核意见接口
        describe: serviceHost + 'zbzh_jnl_eva/get_statistics_info',
        //获取期刊排名
        get_ranking: serviceHost + 'zbzh_solr_api/get_ration',
        //保存期刊排名
        save_ranking: serviceHost + 'zbzh_solr_api/save_ration',
        //保存期刊排名（新）
        save_ranking_new: serviceHost + 'zbZhEvaluate/mcj/journal_move_rank',
        //核心刊扩展刊数量
        getCoreExt: serviceHost + 'zbzh_jnl_eva/get_core_extensions',
        //保存核心刊扩展刊数量
        saveCoreExt: serviceHost + 'zbzh_solr_api/save_core_extensions',
        //获取审核意见
        getAudit: serviceHost + 'zbzh_jnl_eva/get_audit_opinion',
        //保存审核意见
        saveAudit: serviceHost + 'zbzh_jnl_eva/update_audit_opinion',
        //导出
        export: serviceHost + 'zbzh_solr_api/export',
        //多学科核心刊列表
        moreCoreQuery: serviceHost + 'zbzh_jnl_eva/many_subject_query',
        //设置-多学科核心刊
        setMoreCore: serviceHost + 'zbzh_solr_api/many_subject_save',
        //多学科扩展刊列表
        moreExtQuery: serviceHost + 'zbzh_jnl_eva/many_subject_ext_query',
        //设置-多学科扩展刊
        setExtCore: serviceHost + 'zbzh_jnl_eva/many_subject_ext_save',
        //多学科扩展期刊评价 编辑页面信息读取接口
        many_subject_ext_get: serviceHost + 'zbzh_solr_api/get_ration',
        //上版核心期刊
        upper_edition_coreJnl: serviceHost + 'zbzh_jnl_eva/upper_edition_coreJnl',
    },

    //研究人员定性评价
    researcherNature: {
        tree: serviceHost + 'evaluate_subject/tree_yj',// tree
        query: serviceHost + 'yj_dx_jnl_eva/query',//查询
        //多学科核心期刊/多学科扩展期刊评价数量，期刊总数，核心，扩展刊数，是否提交审核意见接口
        describe: serviceHost + 'yj_dx_jnl_eva/get_statistics_info',
        //获取期刊排名
        get_ranking: serviceHost + 'yj_dx_jnl_eva/get_ration',
        //保存期刊排名
        save_ranking: serviceHost + 'yj_dx_jnl_eva/save_ration',
        //核心刊扩展刊数量
        getCoreExt: serviceHost + 'yj_dx_jnl_eva/get_core_extensions',
        //保存核心刊扩展刊数量
        saveCoreExt: serviceHost + 'yj_dx_jnl_eva/save_core_extensions',
        //获取审核意见
        getAudit: serviceHost + 'yj_dx_jnl_eva/get_audit_opinion',
        //保存审核意见
        saveAudit: serviceHost + 'yj_dx_jnl_eva/update_audit_opinion',
    },
    //专家送审表管理
    expertSend: {
        degree: serviceHost + 'expert_ss/degree_detail',//综合隶属度
        //多学科核心期刊/多学科扩展期刊评价数量，期刊总数，核心，扩展刊数，是否提交审核意见接口
        describe: serviceHost + 'expert_ss/query_count_submit',
        //学科概况
        subjectSummary: serviceHost + 'expert_ss/subject_summary_query',
        //Tree
        tree: serviceHost + 'expert_ss/evaluate_subject_tree',
        //query
        query: serviceHost + 'expert_ss/query',
        //批量导出按钮接口
        export: serviceHost + 'expert_ss/export_excel',
        //打开审核意见页面，获取该学科的审核意见信息
        audit_detail: serviceHost + 'expert_ss/audit_detail',
        //保存或提交审核意见。需要填充值的字段有：评价学科ID、审核状态、审核意见；注意：字段status是0为保存，是1为提交。
        save_audit: serviceHost + 'expert_ss/save_audit'

    },
    //专家定性评价
    expertNatureEval: {
        degree: serviceHost + 'expert_dx_jnl_eva/degree_detail',//综合隶属度
        //多学科核心期刊/多学科扩展期刊评价数量，期刊总数，核心，扩展刊数，是否提交审核意见接口
        describe: serviceHost + 'expert_dx_jnl_eva/query_count_submit',
        //学科概况
        subjectSummary: serviceHost + 'expert_dx_jnl_eva/subject_summary_query',
        //Tree
        tree: serviceHost + 'expert_dx_jnl_eva/evaluate_subject_tree',
        //query
        query: serviceHost + 'expert_dx_jnl_eva/query',
        //批量导出按钮接口
        export: serviceHost + 'expert_dx_jnl_eva/export_excel',
        //打开调整排名页面，获取该期刊的定性评价信息
        get_ranking_detail: serviceHost + 'expert_dx_jnl_eva/get_ranking_detail',
        //保存调整期刊的排名和调整理由的接口。需要填充值的字段有：主键记录ID、排名、调整理由
        save_ranking: serviceHost + 'expert_dx_jnl_eva/modify_ranking',
        //获取专家定性核心/扩展刊配置信息接口
        getCoreExt: serviceHost + 'expert_dx_jnl_eva/get_core_extend',
        //提交核心刊数量配置及调整理由的接口
        saveCoreExt: serviceHost + 'expert_dx_jnl_eva/save_core_extend',
        //增加优秀期刊
        addNewJournal: serviceHost + 'expert_dx_jnl_eva/add_new_journal',
        //删除优秀期刊
        delNewJournal: serviceHost + 'expert_dx_jnl_eva/delete_new_journal',
        //根据期刊名称模糊查询当前版次的期刊列表数据
        queryJnameList: serviceHost + 'journal/journal_info/query_jname_list',
        //保存或提交审核意见。需要填充值的字段有：评价学科ID、审核状态、审核意见；注意：字段status是0为保存，是1为提交
        saveAudit: serviceHost + 'expert_dx_jnl_eva/save_audit',
        //打开审核意见页面，获取该学科的审核意见信息
        getAuditOpinion: serviceHost + 'expert_dx_jnl_eva/audit_detail',
        //查询当前选中学科是否已提交审核意见
        queryIsSubmit: serviceHost + 'expert_dx_jnl_eva/query_is_submit',
        //查询当前登录专家的是否还有未提交评审结果或未评审的学科。
        querySubmit: serviceHost + 'expert_dx_jnl_eva/query_submit',
        //查询列表评审记录数据方法
        review_record: serviceHost + 'expert_dx_jnl_eva/review_record',
    },
    /**
     * 专家应聘相关接口
     */
    admin_evaluate_subject: {
        //获取专家选择的评价学科列表（从专家送审表中获取）
        expert_evaluate_list: serviceHost + 'admin_evaluate_subject/expert_evaluate_list',
        //专家提交选择的评价学科数据
        expert_evaluate_save: serviceHost + 'admin_evaluate_subject/expert_evaluate_save',
    },
    /**
     *专家定性评价汇总-资格审查相关接口(包含所有专家定性评价汇总-资格审查相关接口。)
     */
    expert_qualification: {
        detail: serviceHost + 'expert_qualification/esreview_detail',//[get]读取总编对于专家在某个学科评审结果的审核意见信息接口
        evaluate_subject_tree: serviceHost + 'expert_qualification/evaluate_subject_tree',//[get]专家定性评价汇总-资格审查页面左侧学科树接口
        export_excel: serviceHost + 'expert_qualification/export_excel',//[post]批量导出按钮接口
        query: serviceHost + 'expert_qualification/query',//[post]查询专家定性评价汇总-资格审查右侧列表接口
        query_count: serviceHost + 'expert_qualification/query_count',//[get]查询列表上方的参评专家统计数
        review_record: serviceHost + 'expert_qualification/review_record',//[get]查询专家定性评价汇总-资格审查列表上评审记录数据接口
        save: serviceHost + 'expert_qualification/save_esreview',//[post]提交保存总编对于专家在某个学科评审结果的审核意见；注意：状态  已评审是1；无效是9
        recunitList: serviceHost + 'expertInfo/query_recunit_list',//[post]根据推荐单位模糊查询，返回推荐单位的信息列表
    },
    zbDLEvaluateOne: {
        private_for_one_detail: serviceHost + "zbDLEvaluateTwo/detail",//期刊评价详情
        private_for_one_detail2: serviceHost + "zbdl_solr_api/zb_dl2dx_detail",//期刊评价详情
    },
    expert_eval_trace: {
        statistics_query: serviceHost + "expert_eval_trace/statistics_query",//期刊评价详情
    },
    order_submit:{
        get_all_book: serviceHost2 + "bookorder/getAllBook",
        submit: serviceHost2 + "/bookorder/addBookOrder"
    }
};



// WEBPACK FOOTER //
// src/config/accessUrlConfig.js